import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const client = axios.create({ baseURL: API });

// Attach admin token when present
client.interceptors.request.use((config) => {
  const token = localStorage.getItem('mbf_admin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Public
export const createConsultation = (data) => client.post('/consultations', data);
export const createCareer = (data) => client.post('/careers', data);

// Admin auth
export const adminLogin = (password) => client.post('/admin/login', { password });
export const adminVerify = () => client.get('/admin/verify');

// Admin data
export const getConsultations = () => client.get('/admin/consultations');
export const getCareers = () => client.get('/admin/careers');
export const getStats = () => client.get('/admin/stats');
export const updateConsultationStatus = (id, status) => client.patch(`/admin/consultations/${id}`, { status });
export const updateCareerStatus = (id, status) => client.patch(`/admin/careers/${id}`, { status });
export const deleteConsultation = (id) => client.delete(`/admin/consultations/${id}`);
export const deleteCareer = (id) => client.delete(`/admin/careers/${id}`);

export default client;
